export const Role = {
  Master: 'master',
  CS: 'cs',
  Seller: 'seller',
  Finance: 'FINANCE',
  User: 'user',
  Holder: 'HOLDER',
  Creative: 'CREATIVE',
  CustomerCare: 'customer_care'
}